import { ProductApi } from "../api/productApi"

// Create
export const CREATE_PRODUCT = '[Mstore] CREATE_PRODUCT'
export const CREATE_PRODUCT_SUCCESS = '[Mstore] CREATE_PRODUCT_SUCCESS'
export const CREATE_PRODUCT_ERROR = '[Mstore] CREATE_PRODUCT_ERROR'


// Read
export const GET_PRODUCTS = '[Mstore] GET_PRODUCTS'
export const GET_PRODUCTS_SUCCESS = '[Mstore] GET_PRODUCTS_SUCCESS'
export const GET_PRODUCTS_ERROR = '[Mstore] GET_PRODUCTS_ERROR'

// Get
export const GET_PRODUCT = '[Mstore] GET_PRODUCT'
export const GET_PRODUCT_SUCCESS = '[Mstore] GET_PRODUCT_SUCCESS'
export const GET_PRODUCT_ERROR = '[Mstore] GET_PRODUCT_ERROR'

// Search
export const SEARCH_PRODUCT = '[Mstore] SEARCH_PRODUCT'
export const SEARCH_PRODUCT_SUCCESS = '[Mstore] SEARCH_PRODUCT_SUCCESS'
export const SEARCH_PRODUCT_ERROR = '[Mstore] SEARCH_PRODUCT_ERROR'

// Update
export const UPDATE_PRODUCT = '[Mstore] UPDATE_PRODUCT'
export const UPDATE_PRODUCT_SUCCESS = '[Mstore] UPDATE_PRODUCT_SUCCESS'
export const UPDATE_PRODUCT_ERROR = '[Mstore] UPDATE_PRODUCT_ERROR'

// Delete
export const DELETE_PRODUCT = '[Mstore] DELETE_PRODUCT'
export const DELETE_PRODUCT_SUCCESS = '[Mstore] DELETE_PRODUCT_SUCCESS'
export const DELETE_PRODUCT_ERROR = '[Mstore] DELETE_PRODUCT_ERROR'

export const RESET_PRODUCT_UPDATED = '[Mstore] RESET_PRODUCT_UPDATED'
export const RESET_PRODUCT_CREATED = '[Mstore] RESET_PRODUCT_CREATED'

// Create
export const createProduct = (product, productImages, duplicateProduct = false) => {
  return async (dispatch, getState) => {
    dispatch({ type: CREATE_PRODUCT })

    try {
      const res = await ProductApi.createProduct(product)
      dispatch(createProductSuccess(res.data))
      for (let image of productImages) {
        if (image._delete) {
          if (image.id > 0) {
            await ProductApi.removeProductImage(res.data.id, image, { "dependent-source": global.constants.dependentSource.product })
          }
        } else {
          if (duplicateProduct) image.image_url = image.image;
          await ProductApi.createProductImage(res.data.id, image, { "dependent-source": global.constants.dependentSource.product })
        }
      }
      if (duplicateProduct) window.location.href = `/admin/products/edit/${res.data.id}`
      return res
    } catch (error) {
      console.error('createProduct failed:', error)
      dispatch(createProductFailure(error))
      throw error
    }
  }
}

export const createProductSuccess = product => {
  return {
    type: CREATE_PRODUCT_SUCCESS,
    payload: product
  }
}

export const createProductFailure = error => {
  return {
    type: CREATE_PRODUCT_ERROR,
    payload: error
  }
}

//Read
export const getProducts = (params) => {
  return (dispatch, getState) => {
    dispatch({
      type: GET_PRODUCTS
    })

    ProductApi.getProducts(params).then(res => {
      dispatch(getProductsSuccess(res.data))
    })
    .catch(error => {
      dispatch(getProductsFailure(error))
    })
  }
}

export const getProductsSuccess = data => {
  return {
    type: GET_PRODUCTS_SUCCESS,
    payload: data
  }
}

export const getProductsFailure = error => {
  return {
    type: GET_PRODUCTS_ERROR,
    payload: error
  }
}

//Get
export const getProduct = id => {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_PRODUCT
    })
    try {
      const res = await ProductApi.getProduct(id);
      dispatch(getProductSuccess(res.data));
      return res;
    } catch (error) {
      console.error('getProduct failed:', error);
      dispatch(getProductFailure(error));
      throw error;
    }
  }
}

export const getProductSuccess = product => {
  return {
    type: GET_PRODUCT_SUCCESS,
    payload: product
  }
}

export const getProductFailure = error => {
  return {
    type: GET_PRODUCT_ERROR,
    payload: error
  }
}

export const updateProductFailure = error => ({
  type: UPDATE_PRODUCT_ERROR,
  payload: error
})

export const deleteProductFailure = error => ({
  type: DELETE_PRODUCT_ERROR,
  payload: error
})

//Update
export const updateProduct = (id, product, productImages) => {
  return async (dispatch, getState) => {
    //Multiple actions can be sent using the Redux-Thunk middleware
    dispatch({
      type: UPDATE_PRODUCT,
      payload: product
    })
    try {
      const res = await ProductApi.updateProduct(id, product)
      dispatch(updateProductSuccess(res.data))

      for (const image of productImages) {
        if (image._delete) {
          if (!image._id) {
            await ProductApi.removeProductImage(res.data.id, image)
          }
        } else {
          if (image._id) {
            // TODO: Find a way to update existing image
            await ProductApi.createProductImage(res.data.id, image)
          } else {
            await ProductApi.updateProductImage(res.data.id, image)
          }
        }
      }
      return res
    } catch (error) {
      console.error('updateProduct failed:', error)
      dispatch(updateProductFailure(error))
      throw error
    }
  }
}

export const updateProductSuccess = product => {
  return {
    type: UPDATE_PRODUCT_SUCCESS,
    payload: product
  }
}


//Delete
export const deleteProduct = product => {
  return async (dispatch, getState) => {
    dispatch({
      type: DELETE_PRODUCT,
      payload: product
    })

    try {
      const res = await ProductApi.removeProduct(product)
      if (res.status === 204) dispatch(deleteProductSuccess(product))
      return res
    } catch (error) {
      console.error('deleteProduct failed:', error)
      dispatch(deleteProductFailure(error))
      throw error
    }
  }
}

export const deleteProductSuccess = product => {
  return {
    type: DELETE_PRODUCT_SUCCESS,
    payload: product
  }
}

export const resetCreated = () => {
  return {
    type: RESET_PRODUCT_CREATED
  }
}

export const resetUpdated= () => {
  return {
    type: RESET_PRODUCT_UPDATED,
  }
}
